import PalowansOnBreakTable from './PalowansOnBreakTable';

export default PalowansOnBreakTable;
